export default __webpack_public_path__ + "static/zhi-shi-d4fece09cbdbc0a2cd9fd7c899ef7954.jpg";